import { Tab } from '@headlessui/react'
import map from 'lodash/map'
import type { FunctionComponent } from 'react'
import { cn } from '@dreamstack/util/src/cn'

const tabTitleBaseClass =
  'pb-px-8 h-10 font-montserrat text-px-16 min-w-[32px]'
const tabTitleSelectedClass =
  'border-b-[3px] border-solid border-accentroGray-full font-semibold'

const TabTitle: FunctionComponent<
  React.PropsWithChildren<{
    title: string
    index: number
    isLast?: boolean
  }>
> = ({ title, index }) => {
  return (
    <Tab key={index} style={{ verticalAlign: 'top' }}>
      {({ selected }) => (
        <div className={cn(tabTitleBaseClass, selected && tabTitleSelectedClass)}>
          {title}
        </div>
      )}
    </Tab>
  )
}

const TabContent: FunctionComponent<
  React.PropsWithChildren<{
    content: React.ReactNode
    index: number
  }>
> = ({ content, index }) => {
  return (
    <Tab.Panel key={index}>
      <div className="pt-px-24">{content}</div>
    </Tab.Panel>
  )
}

type SimpleTabProps = {
  tabs: {
    title: string
    content: React.ReactNode
  }[]
}

export const SimpleTabs: FunctionComponent<
  React.PropsWithChildren<SimpleTabProps>
> = ({ tabs }) => {
  const titles = map(tabs, (t) => t.title)
  const contents = map(tabs, (t) => t.content)
  return (
    <Tab.Group>
      <Tab.List className="border-b border-accentroGray-200 space-x-px-32">
        {map(titles, (title, index) => (
          <TabTitle key={index} title={title} index={index} />
        ))}
      </Tab.List>
      <Tab.Panels>
        {map(contents, (content, index) => (
          <TabContent key={index} content={content} index={index} />
        ))}
      </Tab.Panels>
    </Tab.Group>
  )
}
